module.exports = __webpack_public_path__ + "static/loto5Bg-812ffb32418bec59127e3a774b1a0467.svg";